/* ============
 * Create Page
 * ============
 *
 * This is the page for adding client group.
 */
import { mapGetters } from 'vuex';
import clientGroupService from './../../../../services/client-group';
import clientGroupTransformer from './../../../../transformers/clientGroup';
import Forms from './../../../../utils/forms/forms';
import priceFieldService from './../../../../services/priceField';
import chartOfAccountsService from './../../../../services/chartOfAccounts';

export default {
  data() {
    return {
      form: new Forms({
        name: {
          value: '',
          type: 'text',
          label: this.$t('form.clientGroups.name.label'),
        },
        description: {
          value: '',
          type: 'textarea',
          label: this.$t('form.clientGroups.description.label'),
        },
        priceFieldId: {
          value: '',
          type: 'select',
        },
        receivables_account_id: {
          value: '',
          type: 'select',
        },
      }),
    };
  },

  created() {
    this.loading = true;
    Promise.all([
      priceFieldService.all(1),
      chartOfAccountsService.all(),
    ]).then(() => {
      this.loading = false;
    });
  },

  computed: {
    ...mapGetters({
      priceFields: 'allPriceFields',
      chartOfAccounts: 'allChartOfAccounts',
    }),
    isInOwnRoute() {
      return this.$route.name === 'clientGroups.create';
    },
  },

  methods: {
    /**
     * Method to store the client group.
     */
    store() {
      this.form.loading = true;
      const clientGroup = clientGroupTransformer.send(this.form.data());
      clientGroupService.store(clientGroup)
      .then(() => {
        this.form.loading = false;
        if (this.isInOwnRoute) {
          this.$message({
            message: this.$t('static.clientGroups.create.success'),
            type: 'success',
          });
          this.$router.push({
            name: 'clientGroups.index',
          });
        } else {
          this.$emit('close');
          clientGroupService.all();
        }
      }).catch((errors) => {
        this.form.loading = false;
        this.form.recordErrors(errors);
      });
    },
  },

  watch: {
    priceFields(priceFields) {
      const options = priceFields.all.map(type => ({
        id: type.id,
        name: type.name,
      }));
      options.splice(0, 0, { id: '', name: '' });
      this.form.setOptions('priceFieldId', options);
    },
    chartOfAccounts(chartOfAccounts) {
      if (chartOfAccounts && chartOfAccounts.all && chartOfAccounts.all.length > 0) {
        const options = chartOfAccounts.all.map(account => ({
          id: account.id,
          name: `${account.code} - ${account.name}`,
        }));
        options.splice(0, 0, { id: '', name: '' });
        this.form.setOptions('receivables_account_id', options);
      }
    },
  },

  components: {
    VForm: require('./../../../../components/form/form.vue'),
  },
};



// WEBPACK FOOTER //
// ./src/app/pages/withNavigation/clientGroups/create/create.js